// extracted by mini-css-extract-plugin
export var downArrow = "_7q-0";
export var infoTooltipIcon = "_7q-3";
export var label = "_7q-1";
export var optionCard = "_7q-4";
export var upArrow = "_7q-2";